// extracted by mini-css-extract-plugin
export default {"emptyState":"FavProductsPage_emptyState__c-dR5","image":"FavProductsPage_image__KQFd2"};